import PropTypes from 'prop-types';
import React from 'react';

import { TextButton } from '@bibliocommons/base-buttons';
import { ShelfMap } from '@bibliocommons/base-icons';

import './StackMapButton.scss';

const StackMapButton = ({ label, onClick }) => {
  return (
    <TextButton className="cp-stack-map-button" dataKey="stack-map-button" handleClick={onClick}>
      <ShelfMap />
      {label}
    </TextButton>
  );
};

StackMapButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default StackMapButton;
